import React, { useEffect, useContext, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AppSettings } from "./../../config/app-settings.js";
import { workOrder } from "../../api";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getStatusColor } from "../../utils/helper.jsx";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { endOfMonth, startOfMonth } from "date-fns";

function CalendarWorkOrder() {
  const context = useContext(AppSettings);
  const plugins = [
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin,
    listPlugin,
    bootstrapPlugin,
  ];
  const headerToolbar = {
    left: "dayGridMonth,timeGridWeek,timeGridDay",
    center: "title",
    right: "prev,next today",
  };
  const buttonText = {
    today: "Today",
    month: "Month",
    week: "Week",
    day: "Day",
  };
  const views = {
    timeGrid: {
      eventLimit: 6,
    },
  };
  const [events, setEvents] = useState();

  const [openDetail, setOpenDetail] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [date, setDate] = useState({
    start: null,
    end:null
  })

  const navigate = useNavigate()


  async function getMachine() {
    try {   

      const res = await workOrder.list({ isRequest: false,...date});
      if (res.ok) {
        const body = await res.json();
        let datas = body.data;
          if (datas) {
            datas.map((item) => {
           item.allDay = true
              item.id = item.id
              item.title = item.title;
              item.start = new Date(item.start_date);
              item.end = new Date(item.due_date);
              item.color = getComputedStyle(document.body)
              .getPropertyValue(`--bs-${getStatusColor(item.status)}`)
              .trim();;
            });
       
            setEvents(datas);
          }
        
        
      }

  
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    
    if (date.start) {
      getMachine();
    }
   

    return function cleanUp() {
      context.setAppContentFullHeight(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, [date]);

  const handleEventClick = (e) => {
    
  
    setSelectedEvent(e.event)
    setOpenDetail(true)
  
      
  }

  return (
    <Card>
      <div className="py-4 d-flex w-100 justify-content-end">
        {['Open', 'In Progress', 'On Hold', 'Completed'].map((s) => {
         
          return <div key={s} style={{marginRight:10}}>
              <span className={`bg-${getStatusColor(s)}`} style={{width:'10px',height:10,borderRadius:'50%',display:'inline-table'}}> </span> {s}
            </div>
       })}
    </div>
      
      <div style={{paddingLeft:'10px'}}>
        <FullCalendar
          datesSet={(e)=>setDate({start:e.start,end:e.end})}
              eventClick={(e)=>handleEventClick(e)}
            plugins={plugins}
            initialView="dayGridMonth"
            themeSystem="bootstrap"
            headerToolbar={headerToolbar}
            buttonText={buttonText}
            events={events}
        views={views}
        
          />
      </div>
         
       
      

      <ConfirmationDlg open={openDetail}
        onClose={() => setOpenDetail(false)}
        btnSubmitText={'Show Detail'}
        onSubmit={() => navigate('/work-order/detail/' + selectedEvent?.id)}
        hideCancelBtn
      >

        {selectedEvent && <Card>
        
          <CardBody>
            <table>
              <tbody>

         
              <tr>
                <td>Title</td>
                <td>:</td>
                <td>{selectedEvent.title}</td>
              </tr>
              <tr>
                <td>Category</td>
                <td>:</td>
                <td>{selectedEvent.extendedProps?.category?.name}</td>
              </tr>
              <tr>
                <td>Description</td>
                <td>:</td>
                <td>{selectedEvent.extendedProps?.description}</td>
              </tr>
              <tr>
                <td>Priority</td>
                <td>:</td>
                <td>{selectedEvent.extendedProps?.priority}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>:</td>
                <td>  <span
          className={`badge border border-${getStatusColor(selectedEvent.extendedProps?.status)
          } text-${getStatusColor(selectedEvent.extendedProps?.status)}`}
        >
          {selectedEvent.extendedProps?.status}
        </span></td>
                </tr>
                </tbody>
            </table>
          </CardBody>
        
        </Card>}

      </ConfirmationDlg>
    
 
    </Card>
  
  );
}

export default CalendarWorkOrder;
